import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const imageLicenses = {
  col1: [
    "\u00a9 vege - Fotolia.com (ID: 61003743)",
    "\u00a9 vege - Fotolia.com (ID: 68888128)",
    "\u00a9 kraftwerk - Fotolia.com (ID: 43816459)",
    "\u00a9 stnazkul - Fotolia.com (ID: 70043857)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 71558445)",
    "\u00a9 ty - Fotolia.com (ID: 69876126)",
    "\u00a9 stnazkul - Fotolia.com (ID: 74318288)",
  ],
  col2: [
    "\u00a9 everythingpossible - Fotolia.com (ID: 75176784)",
    "\u00a9 PRCreativeTeam - Fotolia.com (ID: 32926218)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 60594952)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 71555591)",
    "\u00a9 kalafoto - Fotolia.com (ID: 76548158)",
    "\u00a9 Sergey Nivens - Fotolia.com (ID: 75074205)",
    "\u00a9 Minerva Studio - Fotolia.com (ID: 44001165)",
  ],
  col3: [
    "\u00a9 ty - Fotolia.com (ID: 77611976)",
    "\u00a9 Brian Jackson - Fotolia.com (ID: 71272430)",
    "\u00a9 vege - Fotolia.com (ID: 68009271)",
    "\u00a9 vege - Fotolia.com (ID: 69466546)",
    "\u00a9 lenetsnikolai - Fotolia.com (ID: 79605839)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 67233512)",
    "\u00a9 vege - Fotolia.com (ID: 68666829)",
  ],
  col4: [
    "\u00a9 vege - Fotolia.com (ID: 64727666)",
    "\u00a9 vege - Fotolia.com (ID: 68576622)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 53066900)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 68132249)",
    "\u00a9 vege - Fotolia.com (ID: 70085709)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 71555523)",
    "\u00a9 bloomua - Fotolia.com (ID: 44334833)",
    "\u00a9 vege - Fotolia.com (ID: 69992403)",
  ],
};

export default function ImprintFrPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PageHead
        title="Mentions Légales | NetBasis International"
        description="Mentions légales, avis de non-responsabilité et crédits photographiques de NetBasis International conformément aux exigences réglementaires."
        ogUrl="https://net-basis.net/fr/mentions-legales"
      />
      <Header />
      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero Image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src="https://net-basis.net/Bilder/netbasis-legal-notice-privacy-policy.webp"
                alt="Mentions légales"
                title="Mentions légales"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <div className="flex flex-col md:flex-row gap-10 md:gap-12 lg:gap-16">
              {/* Left Column - 1/3 */}
              <div className="w-full md:w-1/3">
                <section>
                  <h1 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
                    Mentions légales
                  </h1>

                  <div className="space-y-6">
                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Mentions selon le § 5 DDG
                      </h2>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed whitespace-pre-line">
                        Christof Günther{'\n'}NetBasis International{'\n'}Heinrichstraße 45{'\n'}40239 Düsseldorf{'\n'}Allemagne
                      </p>
                    </div>

                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Contact
                      </h2>
                      <div className="font-body text-sm md:text-base text-foreground-950 leading-relaxed space-y-1">
                        <p>
                          <span className="text-foreground-950">Téléphone :</span>{" "}
                          <a
                            href="tel:+4921154419380"
                            className="text-foreground-950 hover:underline transition-colors cursor-pointer"
                          >
                            +49 (0) 211 / 544 193 80
                          </a>
                        </p>
                        <p>
                          <span className="text-foreground-950">Email :</span>{" "}
                          <a
                            href="mailto:contact@net-basis.com"
                            className="text-foreground-950 hover:underline transition-colors cursor-pointer"
                          >
                            contact@net-basis.com
                          </a>
                        </p>
                        <p>
                          <span className="text-foreground-950">Internet :</span>{" "}
                          <a
                            href="https://net-basis.net/fr"
                            className="text-foreground-950 hover:underline transition-colors cursor-pointer"
                          >
                            net-basis.net
                          </a>
                        </p>
                      </div>
                    </div>

                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Numéro d&apos;identification TVA
                      </h2>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed whitespace-pre-line">
                        Numéro d&apos;identification de la taxe sur la valeur ajoutée conformément au § 27 a de la loi sur la TVA :{'\n'}DE 258 486 954
                      </p>
                    </div>

                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Assurance RC Pro
                      </h2>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed whitespace-pre-line">
                        Nom et siège social de la compagnie :{'\n'}Hiscox AG agissant pour le compte de Hiscox Insurance Company Ltd.{'\n'}Succursale pour l&apos;Allemagne, Arnulfstraße 31, 80636 Munich{'\n'}Couverture: Mondiale
                      </p>
                    </div>
                  </div>
                </section>
              </div>

              {/* Right Column - 2/3 */}
              <div className="w-full md:w-2/3">
                <section>
                  <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
                    Avertissement légal
                  </h2>

                  <div className="space-y-6">
                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Responsabilité du contenu
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        Le contenu de notre site web a été élaboré avec le plus grand soin. Cependant, nous ne pouvons pas garantir l&apos;exactitude, l&apos;exhaustivité et l&apos;actualité du contenu. En tant que fournisseur de services, nous sommes responsables de notre propre contenu sur ces pages conformément aux lois générales. Nous ne sommes toutefois pas tenus de surveiller les informations de tiers transmises ou stockées, ni de rechercher des circonstances indiquant une activité illégale. Les obligations de supprimer ou de bloquer l&apos;utilisation d&apos;informations en vertu des lois générales restent inchangées. Toutefois, la responsabilité à cet égard n&apos;est possible qu&apos;à partir du moment où nous avons connaissance d&apos;une violation spécifique. Dès que nous avons connaissance de violations légales correspondantes, nous supprimerons immédiatement ce contenu.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Responsabilité des liens
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        Notre offre contient des liens vers des sites web externes de tiers sur le contenu desquels nous n&apos;avons aucune influence. Par conséquent, nous ne pouvons assumer aucune responsabilité pour ces contenus externes. Le fournisseur ou l&apos;exploitant respectif des pages liées est toujours responsable du contenu des pages liées. Les pages liées ont été vérifiées au moment de la création du lien pour d&apos;éventuelles violations légales. Aucun contenu illégal n&apos;était reconnaissable au moment de la création du lien. Cependant, un contrôle permanent du contenu des pages liées n&apos;est pas raisonnable sans indices concrets d&apos;une violation de la loi. Dès que nous avons connaissance de violations légales, nous supprimerons immédiatement ces liens.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Droit d&apos;auteur
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        Le contenu et les œuvres créées ou utilisées par nous sur ces pages sont soumis au droit d&apos;auteur allemand. La reproduction, le traitement, la distribution et toute forme d&apos;exploitation en dehors des limites du droit d&apos;auteur nécessitent notre consentement. Les téléchargements et copies de ce site ne sont autorisés que pour un usage privé et non commercial. Dans la mesure où le contenu de notre site n&apos;a pas été créé par nous, les droits d&apos;auteur des tiers sont respectés. En particulier, le contenu de tiers est identifié comme tel. Si vous deviez néanmoins avoir connaissance d&apos;une violation du droit d&apos;auteur, nous vous prions de nous en informer. Dès que nous avons connaissance de violations légales, nous supprimerons immédiatement ce contenu.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Crédits images
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        Les images Fotolia/Adobe Stock utilisées sur ce site web ont été correctement licenciées. Veuillez consulter l&apos;aperçu suivant pour les mentions de copyright détaillées :
                      </p>
                      <div className="mt-4 w-full">
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-1">
                          {imageLicenses.col1.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                          {imageLicenses.col2.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                          {imageLicenses.col3.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                          {imageLicenses.col4.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}